import React, { Fragment, useState, useEffect } from 'react';
import { Link, useMatch, useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { searchprofile, getCurrentProfile } from '../../actions/profile';

/*
  NOTE: declare initialState outside of component
  so that it doesn't trigger a useEffect
  we can then safely use this to construct our profileData
 */
const initialState = {
  // company: '',
  // website: '',
  // location: '',
  // status: '',
  // skills: '',
  // githubusername: '',
  // bio: '',
  // twitter: '',
  // facebook: '',
  // linkedin: '',
  // youtube: '',
  // instagram: ''
  apid: '', name: '', email: '', hsc: '', search: ''
};

const ProfileForm = ({
  auth: { user },
  profile: { profile, loading },
  searchprofile,
  getCurrentProfile
}) => {
  const [formData, setFormData] = useState(initialState);

  const creatingProfile = useMatch('/search-profile');

  // const [displaySocialInputs, toggleSocialInputs] = useState(false);

  const navigate = useNavigate();

  // useEffect(() => {
  //   // if there is no profile, attempt to fetch one
  //   if (!profile) getCurrentProfile();

  //   // if we finished loading and we do have a profile
  //   // then build our profileData
  //   if (!loading && profile) {
  //     const profileData = { ...initialState };
  //     for (const key in profile) {
  //       if (key in profileData) profileData[key] = profile[key];
  //     }
  //     for (const key in profile.social) {
  //       if (key in profileData) profileData[key] = profile.social[key];
  //     }
  //     // the skills may be an array from our API response
  //     if (Array.isArray(profileData.skills))
  //       profileData.skills = profileData.skills.join(', ');
  //     // set local state with the profileData
  //     setFormData(profileData);
  //   }
  // }, [loading, getCurrentProfile, profile]);

  const { apid, name, email, hsc, search  } = formData;

  const onChange = (e) =>
    setFormData({ ...formData, [e.target.name]: e.target.value });

  const onSubmit = async (e) => {
    e.preventDefault();
    var tobesent = {};
    tobesent.username = user.username;
    tobesent.tfcname = user.tfcname;
    tobesent.tfccode = user.tfccode;
    tobesent.ltype = user.ltype;
    tobesent.searc = formData.search;
    console.log(tobesent);
    await searchprofile(tobesent, navigate);
    // if(profile !== null && profile !== undefined)
    //   await getCurrentProfile(profile.e);
  };

  return (
    <section className="container">
      {/* <h1 className="large text-primary">
        {creatingProfile ? 'Create Your Profile' : 'Edit Your Profile'}
      </h1>
      <p className="lead">
        <i className="fas fa-user" />
        {creatingProfile
          ? ` Let's get some information to make your`
          : ' Add some changes to your profile'}
      </p>
      <small>* = required field</small> */}
      <form className="form" onSubmit={onSubmit}>
        {/* <div className="form-group">
          <select name="status" value={status} onChange={onChange}>
            <option>* Select Professional Status</option>
            <option value="Developer">Developer</option>
            <option value="Junior Developer">Junior Developer</option>
            <option value="Senior Developer">Senior Developer</option>
            <option value="Manager">Manager</option>
            <option value="Student or Learning">Student or Learning</option>
            <option value="Instructor">Instructor or Teacher</option>
            <option value="Intern">Intern</option>
            <option value="Other">Other</option>
          </select>
          <small className="form-text">
            Give us an idea of where you are at in your career
          </small>
        </div> */}
        <div className="form-group">
          <input
            type="text"
            placeholder=""
            name="search"
            value={search}
            onChange={onChange}
          />
          <small className="form-text" style={{color: "brown", fontWeight: "bold"}}>
            enter application number (or) email (or) mobile number (or) hsc register number to search
          </small>
        </div>



        <input type="submit" className="btn btn-primary my-1" value="Search"/>
        <Link className="btn btn-light my-1" to="/dashboard">
          Go Back
        </Link>
      </form>
    </section>
  );
};

ProfileForm.propTypes = {
  searchprofile: PropTypes.func.isRequired,
  getCurrentProfile: PropTypes.func.isRequired,
  profile: PropTypes.object.isRequired
};

const mapStateToProps = (state) => ({
   auth: state.auth,
  profile: state.profile
});

export default connect(mapStateToProps, { searchprofile, getCurrentProfile })(
  ProfileForm
);
